var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", [
    _c(
      "svg",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show"
          }
        ],
        staticClass: "spinner",
        class: { show: _vm.show },
        attrs: { width: "28px", height: "28px", viewBox: "0 0 28 28" }
      },
      [
        _c("circle", {
          staticClass: "path",
          attrs: {
            fill: "none",
            "stroke-width": "4",
            "stroke-linecap": "round",
            cx: "14",
            cy: "14",
            r: "14"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Spinner.vue?vue&type=template&id=39432f99&
// module id = 864
// module chunks = 1